<template>
  <v-overlay :value="loadingDownloadData" absolute opacity="0.1">
    <center>
      <img
        width="100"
        :src="require('@/assets/img/magnifier-zoom-search.gif')"
      />
      <div class="text-center" style="color: #077893">
        <h3 class="text-center">{{ $t("overlay.load") }}</h3>
      </div>
    </center>
  </v-overlay>
</template>
<script>
export default {
  name: 'portal_overlay_seacrh',
  data: () => ({
    loadingDownloadData: true
  })
}
</script>
